import React from 'react';
import InlinePost from './inline_post';

export default function InlineAnswer(props)
{
    const item = props.item;
    const showComment = item.hasComments;
    return (
        <div className={'answer-wrapper' + (item.approved ? ' answer-wrapper-approved' : '')}>
            <InlinePost
                showshow_vote={props.show_vote}
                on_comment_post={props.on_comment_post}
                on_approve_post={props.on_approve_post}
                key={item.id}
                item={item}
                type="answer"/>
            {
                showComment ?
                    <div>
                        <div className='comments-wrapper'>
                        <h4><i className='fa-solid fa-comment'></i> {(item.comments.length > 1) ? 'Comments' : 'Comment'}</h4>
                            {item.comments.map(comment =>
                            (
                                <InlinePost key={comment.id} item={comment} type="comment" on_comment_post={props.on_comment_post}/>
                            ))}
                        </div>
                    </div> :
                    <></>
            }
        </div>
    );
};